<template>
  <div id="app">
    <the-navbar/>
    <the-notification/>
    <router-view/>
  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar/TheNavbar'
import TheNotification from '@/components/TheNotification/TheNotification'
import session from '@/utilities/session.js'
import { JSConn } from '@/utilities/js-conn.js'

export default {
  name: 'App',
  mounted: function () {
    this.checkSignIn()
  },
  methods: {
    checkSignIn () {
      const jsConn = new JSConn()
      jsConn.fromRoutePath = this.$router.currentRoute.path
      jsConn.toRoutePath = this.$router.currentRoute.path
      session.updateSession(jsConn)
    }
  },
  components: {
    TheNavbar,
    TheNotification
  }
}
</script>

<style lang="scss">
@import "./assets/scss/app.scss";

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.bote-number {
    font-family: monospace
}

td .button {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
}

// 2018-03-22 override for hover on table rows
// it was always white before this setting
.content table tr:hover {
    background-color: #ADB295;
}

.navbar-item.has-dropdown:hover .navbar-link,
.navbar-item.has-dropdown.is-active .navbar-link {
    background-color: #ADB295;
}
.autocomplete .dropdown-item.is-hovered,
.autocomplete .dropdown .dropdown-menu .has-link a.is-hovered,
.dropdown .dropdown-menu .has-link .autocomplete a.is-hovered {
    background-color: #ADB295;
    background: #ADB295;
    color: #0a0a0a;
}

a.dropdown-item:hover,
.dropdown .dropdown-menu .has-link a:hover {
    background-color: #ADB295;
    color: #0a0a0a;
}
</style>
